import {
  Component,
  Input,
  Output,
  OnInit,
  EventEmitter,
  AfterContentInit,
} from '@angular/core';
import { Router } from '@angular/router';

import {
  TaskDTO,
  ActionTypeDTO,
  UserDTO,
  TaskTypeDTO,
  ActionDTO,
} from '../api/plyca-dtos';
import { TaskService } from './task.service';
import { ServiceLocator } from './../ServiceLocator';
import { TranslateService } from '@ngx-translate/core';
import { UIService } from '../ui.service';
import {
  searchGenericComponent,
  SearchSettingDTOModal,
} from '../components/search/searchGeneric.component';
import {
  ActionDefinitionDTO,
  ActionParameterDefinitionDTO,
} from '../api/plyca-dtos-v2';
import { AppState } from '../store/AppState';
import { SessionInfo } from '../api/UserPrefs-dto';
import { Store } from '@ngrx/store';
import { DossierLinkService } from '../dossiers/components/dossierLink.service';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { PlycaDataService } from '../../services/plyca.service';
import { ActionsProcessComponent } from '../actions/actions.process.component';
import { UserService } from '../user.service';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';
import { ConfirmationService, MenuItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { SET_VARIABLES } from '../dossiers/dossierActions/setVariables.component';

@Component({
  selector: 'task-actions',
  templateUrl: 'task.actions.template.html',
  providers: [DialogService, UIService],
})
export class taskActionsComponent extends BaseComponent implements OnInit {
  @Input()
  task: TaskDTO;
  @Input()
  usuid: string;
  @Input()
  inboxid: string;

  @Output()
  reload = new EventEmitter();

  private router: Router;
  public taskService: TaskService;

  private translateService: TranslateService;
  private uiService: UIService;

  items: MenuItem[] = [];
  public user: UserDTO;
  confirmationService: ConfirmationService;

  constructor(
    private dialogService: DialogService,
    private dossierLinkService: DossierLinkService,
    public userService: UserService,
    protected plycaService: PlycaDataService,
    private plycaErrorHandler: PlycaErrorHandler,
    private store: Store<AppState>
  ) {
    super();
    this.uiService = ServiceLocator.injector.get(UIService);
    this.taskService = ServiceLocator.injector.get(TaskService);
    this.translateService = ServiceLocator.injector.get(TranslateService);
    this.router = ServiceLocator.injector.get(Router);
    this.confirmationService = ServiceLocator.injector.get(ConfirmationService);

    this.taskService = ServiceLocator.injector.get(TaskService);
  }

  ngOnInit(): void {
    this.subscribe(this.store.select('user'), (sesInfo: SessionInfo) => {
      this.user = sesInfo.user;
    });

    let mn: MenuItem = {};
    if (this.lockLink(this.task) && !this.usuid && !this.inboxid) {
      mn = <MenuItem>{};
      this.subscribe(
        this.translateService.get('General.open'),
        (res: string) => {
          mn.label = res;
        }
      );
      mn.icon = 'fa fa-open';
      mn.command = (event: Event) => {
        this.openTask();
      };
      this.items.push(mn);
    }
    if (this.unlockLink(this.task)) {
      mn = <MenuItem>{};
      this.subscribe(
        this.translateService.get('General.unlock'),
        (res: string) => {
          mn.label = res;
        }
      );
      mn.icon = 'fa fa-unlock';
      mn.command = (event: Event) => {
        this.unlock();
      };
      this.items.push(mn);
    }
    if (this.redirectLink(this.task)) {
      mn = <MenuItem>{};
      this.subscribe(
        this.translateService.get('General.redirect'),
        (res: string) => {
          mn.label = res;
        }
      );
      mn.icon = 'fas fa-share';
      mn.command = (event: Event) => {
        this.openSearchGeneric();
      };
      this.items.push(mn);
    }
    if (this.userService.hasRoles('0,50')) {
      mn = <MenuItem>{};
      this.subscribe(this.translateService.get('Variables'), (res: string) => {
        mn.label = res;
      });
      mn.icon = 'fas fa-arrow-circle-right';
      mn.command = (event: Event) => {
        this.openVariables();
      };
      this.items.push(mn);
    }

    if (this.userService.hasRoles('0,50')) {
      mn = <MenuItem>{};
      this.subscribe(
        this.translateService.get('Info. soporte'),
        (res: string) => {
          mn.label = res;
        }
      );
      mn.icon = 'fas fa-cog';
      mn.command = (event: Event) => {
        this.openAction('TASKS_INFO');
      };
      this.items.push(mn);
    }
    let dossierLinksItems: MenuItem[] = [];

    dossierLinksItems = this.dossierLinkService.getDossierLinks(
      this.task.division.project.identifier,
      true,
      this.task.division.project.documentClass
        ? this.task.division.project.documentClass.identifier
        : '00000'
    );

    this.items = this.items.concat(dossierLinksItems);
  }

  openVariables() {


    let config: DynamicDialogConfig = {
      header: this.task.description,
      width: '80%',
      styleClass: 'actionStyle',
    };
    config['action'] = 'SET_TASK_VARIABLES';
    config['dto'] = this.task;

    return this.dialogService.open(SET_VARIABLES, config);
  }

  openActionModal(action: ActionDTO) {

    let config: DynamicDialogConfig = {
      header: action.name,
      width: '70%',
      styleClass: 'actionStyle',
    };
    config['action'] = action;
    config['dto'] = action.target;

    return this.dialogService.open(ActionsProcessComponent, config);
  }

  public openAction(actionName: string) {
    this.subscribe(this.plycaService.getAction(actionName), (datos: any) => {
      if (datos && datos.content) {
        let actionDefinition: ActionDefinitionDTO = datos.content[0];

        if (actionDefinition && actionDefinition.executableAction) {
          let act = actionDefinition.executableAction;
          act.target = this.task;
          act.parameters = act.parameters.filter(
            (param) => param.name !== 'TARGET'
          );

          this.subscribe(
            this.openActionModal(actionDefinition.executableAction).onClose,
            () => this.load()
          );
        }
      }
    });
  }
  public load() { }

  public openTask(): void {
    if (this.task) {
      this.taskService.openTask(this.task);
      // this.reload.emit();
    } else {
      console.log('Tarea nula');
    }
  }

  unlock(): void {
    this.subscribe(
      this.taskService.unlockTask(this.task),
      (ok: any) => { },
      (err: any) => this.plycaErrorHandler.showServerError(err)
    );
    this.reload.emit();
  }

  unlockLink(task: TaskDTO): boolean {
    // let action = task.availableActions.actions.filter(x => (x.identifier === ActionTypeDTO.TASK_UNLOCK));
    // return action.length > 0;
    return this.taskService.isActionAvailable(task, ActionTypeDTO.TASK_UNLOCK);
  }

  lockLink(task: TaskDTO): boolean {
    // let action = task.availableActions.actions.filter(x => (x.identifier === ActionTypeDTO.TASK_LOCK));
    // return action.length > 0;
    return this.taskService.isActionAvailable(task, ActionTypeDTO.TASK_LOCK);
  }

  redirectLink(task: TaskDTO): boolean {
    return this.taskService.isActionAvailable(
      task,
      ActionTypeDTO.TASK_REDIRECT
    );
  }
  redirect(inboxIdentifier: string): void {
    this.subscribe(
      this.taskService
        .redirectTask(this.task, inboxIdentifier)
        .pipe(finalize(() => { })),
      (ok: any) => {
        this.uiService.showSuccess(
          this.translateService.instant('Tasks.redirect.message') +
          '(' +
          inboxIdentifier +
          ')',
          this.translateService.instant('General.info'),
          'success'
        );
      },
      (err: any) => this.plycaErrorHandler.showServerError(err)
    );
    this.reload.emit();
  }

  openSearchGeneric() {
    // Procesamos los parámetros requeridos para el buscador que se está intentando abrir

    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let param = new ActionParameterDefinitionDTO();
    param.identifier = 'BUZON.USUARIOSNOBLOQUEADOS';
    param.value = 'true';
    parametersURL.push(param);

    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'PERFILBUZON.APLICACION';
    param1.value = this.task.division.documentClass.application;
    parametersURL.push(param1);

    if (this.task.profile && this.task.profile.identifier && !this.task.profile.dynamic) {
      let param2 = new ActionParameterDefinitionDTO();
      param2.identifier = 'PERFILBUZON.PERID';
      param2.value = this.task.profile.identifier;
      parametersURL.push(param2);
    }

    let param3 = new ActionParameterDefinitionDTO();
    param3.identifier = 'BUZON.EXCLUIRBUZONESUSUARIO';
    param3.value = 'false';
    parametersURL.push(param3);

    let param4 = new ActionParameterDefinitionDTO();
    param4.identifier = 'PERFILBUZON.USUARIO';
    param4.value = this.user.identifier;
    parametersURL.push(param4);

    let param5 = new ActionParameterDefinitionDTO();
    param5.identifier = 'ORGANISMO.RUTA';
    param5.value = this.user.organizationalUnit;
    parametersURL.push(param5);

    if (
      this.task.type === TaskTypeDTO.TIPO_FIRMA ||
      this.task.type === TaskTypeDTO.TIPO_FIRMA_MASIVA
    ) {
      let param6 = new ActionParameterDefinitionDTO();
      param6.identifier = 'USUARIO.TIENEFIRMA';
      param6.value = 'true';
      parametersURL.push(param6);
    }

    if (this.task.inbox && this.task.inbox.identifier) {
      const param7 = new ActionParameterDefinitionDTO();
      param7.identifier = 'TAREA.BUZONID';
      param7.value = this.task.inbox.identifier;
      parametersURL.push(param7);
    }


    // Contexto que se le pasa al componente
    let contextSearch = new SearchSettingDTOModal('INBOX', true, parametersURL);

    let config: DynamicDialogConfig = {
      header: this.translateService.instant('InBox.select'),
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle',
    };
    config['context'] = contextSearch;
    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose, (result) => {
      if (result) {
        this.confirmationService.confirm({
          message: this.translateService.instant(
            'General.confirm.action.execute'
          ),
          accept: () => {
            this.redirect(result.identifier);
          },
        });
        console.log(result);
      }
    });
  }
}
